import { useBrandContact, useLiveTranslation } from "../lib/LiveContext";
import { cmsPageProps } from "../lib/pageProps";
import Link from "next/link";
import React from "react";
import Meta from "../layouts/Meta";
import StaticContainer from "../layouts/StaticContainer";
import styles from "../styles/pages/privacy.module.scss";
import { contactFacts } from "../constants/company";

const Privacy = () => {
  const { t } = useLiveTranslation("privacy");
  const { addressLines } = contactFacts(useBrandContact());

  return (
    <StaticContainer title={t("title")}>
      <Meta
        title={t("title")}
        description={t("meta-description")}
        keywords={t("meta-keyword")}
      />

      <div className={styles.privacyPageContent}>
        <h2>{t("what-info-h2")}</h2>
        <p>{t("what-info-p")}</p>

        <h2>{t("when-collect-h2")}</h2>
        <p>{t("when-collect-p")}</p>

        <h2>{t("how-use-h2")}</h2>
        <p>{t("how-use-p")}</p>
        <ul>
          <li>{t("how-use-li1")}</li>
          <li>{t("how-use-li2")}</li>
        </ul>

        <h2>{t("cookies-h2")}</h2>
        <p>{t("cookies-p")}</p>

        <h2>{t("third-disclosure-h2")}</h2>
        <p>{t("third-disclosure-p")}</p>

        <h2>{t("third-links-h2")}</h2>
        <p>{t("third-links-p")}</p>

        <h2>{t("google-h2")}</h2>
        <p>
          <a
            href="https://support.google.com/adwordspolicy/answer/1316548?hl=en"
            target="_blank"
          >
            {t("google-p")}
          </a>{" "}
          {t("google-p2")}
        </p>

        <h2>{t("opt-out-h2")}</h2>
        <p>{t("opt-out-p")}</p>

        <h2>{t("coppa-h2")}</h2>
        <p>{t("coppa-p")}</p>

        <h2>{t("can-spam-h2")}</h2>
        <p>{t("can-spam-p")}</p>

        <h2>{t("collect-email-h2")}</h2>
        <ul>
          <li>{t("collect-email-li1")}</li>
          <li>{t("collect-email-li2")}</li>
        </ul>
        <p>{t("collect-email-p1")}</p>
        <ul>
          <li>{t("collect-email-li3")}</li>
          <li>{t("collect-email-li4")}</li>
          <li>{t("collect-email-li5")}</li>
          <li>{t("collect-email-li6")}</li>
          <li>{t("collect-email-li7")}</li>
          <li>{t("collect-email-li8")}</li>
        </ul>
        <p>{t("collect-email-p2")}</p>

        <h2>{t("disclosure-h2")}</h2>
        <p>{t("disclosure-p")}</p>

        <h2>{t("changes-h2")}</h2>
        <p>{t("changes-p")}</p>

        <h2>{t("complaints-h2")}</h2>
        <p>
          {t("complaints-p")}{" "}
          <Link href="/contact-us">{t("complaints-p2")}</Link>
        </p>
        <p>
          {addressLines.map((line, i) => (
            <React.Fragment key={line}>
              {i > 0 && <br />}
              {line}
            </React.Fragment>
          ))}
        </p>
      </div>
    </StaticContainer>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await cmsPageProps(locale, ["privacy"])),
  },
  revalidate: 60,
});

export default Privacy;
